// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6830579","453":"5c9c4f93","667":"74cf3f2a"}[chunkId] + ".chunk.js";
};